const navigation = {
  main: [
    { name: "Home", href: "/" },
    { name: "About", href: "/about" },
    { name: "FAQ", href: "/faq" },
    { name: "Contact", href: "/contact" },
    { name: "More Information", href: "/info" },
    { name: "Privacy", href: "https://decimamedia.com/legal/privacy-policy" },
    {
      name: "Terms of Use",
      href: "https://decimamedia.com/legal/terms-of-use",
    },
    { name: "Decima", href: "https://decimamedia.com" },
  ],
};

export default function Footer() {
  return (
    <footer className="isolate bg-white">
      <div className="mx-auto max-w-7xl overflow-hidden px-4 py-4 sm:px-6 sm:py-6 lg:px-8 lg:py-8">
        <nav
          className="grid grid-cols-2 gap-4 sm:flex sm:flex-wrap sm:justify-center sm:space-x-6"
          aria-label="Footer"
        >
          {navigation.main.map((item) => (
            <div key={item.name} className="w-full sm:w-auto pb-4 sm:pb-0">
              <a
                href={item.href}
                className="block text-center text-sm leading-6 text-gray-900 hover:text-sky-500"
                target={item.href.startsWith("http") ? "_blank" : "_self"}
                rel={item.href.startsWith("http") ? "noopener noreferrer" : ""}
              >
                {item.name}
              </a>
            </div>
          ))}
        </nav>
        <p className="mt-4 text-center text-xs leading-5 text-gray-500 sm:mt-6">
          &copy; {new Date().getFullYear()} Graceful Journey LLC. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
